import { render, staticRenderFns } from "./Newslettercontact.vue?vue&type=template&id=24a188f0"
import script from "./Newslettercontact.vue?vue&type=script&lang=js"
export * from "./Newslettercontact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports